import React from "react";
import { Button } from "components/ui";

interface OfferAuthEmailContinueButtonProps {
  onClick: () => void;
  disabled: boolean;
  loading: boolean;
  label: string;
}

const OfferAuthEmailContinueButton = ({
  onClick,
  disabled,
  loading,
  label,
}: OfferAuthEmailContinueButtonProps) => (
  <Button
    type="unstyled"
    className="w-full flex justify-center p-3 rounded-md  text-sm font-semibold text-white bg-landing-red hover:bg-hover-landing-red focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black focus:ring-red-400 disabled:opacity-75 disabled:pointer-events-none"
    dataTestid="confirm-button"
    onClick={onClick}
    disabled={disabled}
  >
    {loading ? (
      <span className="flex animate-spin mr-3">
        <span className="rounded-full border-2 border-white border-b-black h-4 w-4" />
      </span>
    ) : null}
    {label}
  </Button>
);

export default OfferAuthEmailContinueButton;
